module.exports = {
          srcSet: __webpack_public_path__ + "img/7ff8e7e-804.jpg"+" 804w",
          images:[ {path: __webpack_public_path__ + "img/7ff8e7e-804.jpg",width: 804,height: 489}],
          src: __webpack_public_path__ + "img/7ff8e7e-804.jpg",
          toString:function(){return __webpack_public_path__ + "img/7ff8e7e-804.jpg"},
          
          width: 804,
          height: 489
        }